// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Divider, Stack, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Dialog, Icon, Label, Tag } from "components"

// Config
import { API, Enums, Mask } from "config"

// Screens
import { Authenticate } from "screens"

export default function Approve({ data, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ loading, setLoading ] = useState(false)
    const status = Enums.TransactionStatus.data(data?.status)
    const authenticate = useDisclosure()

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/transactions/${data.id}/approve`)
            toast({ title: 'Pagamento aprovado com sucesso', status: 'success' })
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível aprovar o pagamento.', description: err?.response?.data?.message, status: 'warning'})
        }

        setLoading(false)
    }

    return(
    <>
    <Dialog title={`Aprovar pagamento #${data?.cod}`} loading={loading} {...props}>
        <AlertDialogBody fontSize="sm">
            Você está prestes a aprovar manualmente o recebimento de uma transação. Fique atento e sempre anexe o comprovante.

            <Stack mt={4}>
                <Label label="Valor da transação:" fontSize="lg" fontWeight="bold" children={`R$ ${Mask.price(data.amount)}`} />
                <Label label="Forma de pagamento:" fontSize="lg" children={data?.method_label} />
                <Label label="Status:" fontSize="lg" children={<Tag colorScheme={status.colorScheme} children={status.label} />} />
            </Stack>

            <Divider my={4} />

            <Alert>Comprovantes de pagamento podem ser anexados direto ao pedido na aba <b>Arquivos</b> dentro do pedido.</Alert>
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup variant="ghost" size="sm" isDisabled={loading}>
                <Button children="Confirmar recebimento" colorScheme="teal" leftIcon={<Icon name="check" />} isLoading={loading} loadingText="Aprovando pagamento..." onClick={authenticate.onOpen} />
                <Button children="Fechar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>

    <Authenticate {...authenticate} onSuccess={handleSubmit} />
    </>
    )
}